import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { loginUser, registerUser ,clearMessage } from "../store/userSlice";
import './Login.css';
import { TextField, Button, CircularProgress, Typography, Box } from '@mui/material';
import { showSnackbar } from '../store/snackbarSlice';
import {usePermissions} from '../services/PermissionsContext'


export default function Login() {
  const dispatch = useDispatch();
  const [login, setLogin] = useState('');
  const [email, setEmail] = useState('');
  const [ownerName, setOwnerName] = useState('');
  const [password, setPassword] = useState('');
  const [displayLogin, setDisplayLogin] = useState(true);
  const navigate = useNavigate(); // Initialize the navigate hook

 
  const { user, loading, error, message } = useSelector((state) => state.user);
  const { permissions, updatePermission } = usePermissions();

useEffect(() => {
  if (user) {
    updatePermission(); // Update permissions when user changes
  }
}, [user]); // Run only when `user` changes

useEffect(() => {
  if (permissions && user) {
    const defaultRoute = permissions.defaultRouting || '/Dashboard';
    navigate(defaultRoute);
  }
}, [permissions, user, navigate]); // Wait for `permissions` to update before navigating


  useEffect(() => {
    
    if (message) {
      alert(message)
      dispatch(showSnackbar({ message: message, severity: 'success' }));
      clearMessage()
    }
    if (error) {
      dispatch(showSnackbar({ message: error, severity: 'warning' }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error, message]);

  const handleSignIn = (e) => {
    e.preventDefault();
    dispatch(loginUser({ login, password }));
  };

  const handleRegister = (e) => {
    e.preventDefault();
    const userToRegister = {
      login: login,
      email: email,
      password: password,
      ownerName: ownerName,
    };
    dispatch(registerUser(userToRegister));
  };

  return (
    <div className="gs-shop">
      <Typography variant="h4" className="gs-shop-title">
        Welcome to GS-SHOPSOLUTION
      </Typography>
      <div className="form-wrapper">
        {displayLogin && (
          <div className="sign-in-wrapper">
            <form className="sign-in-form" onSubmit={handleSignIn}>
              <Typography variant="h5" className="sign-in-title">
                Sign in
              </Typography>
              {loading && (
                <CircularProgress size={24} className="loading-message" />
              )}
              <TextField
                className="input-field"
                label="Login"
                variant="outlined"
                fullWidth
                value={login}
                onChange={(e) => setLogin(e.target.value)}
                margin="normal"
              />
              <TextField
                className="input-field"
                label="Password"
                variant="outlined"
                type="password"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                margin="normal"
              />
              <Button
                className="submit-button"
                variant="contained"
                color="primary"
                type="submit"
                disabled={loading}
                fullWidth
              >
                Sign In
              </Button>
              <Box marginTop={2}>
                <Link className="forgot-password-link" to="/forgot-password">
                  Forgot your password?
                </Link>
              </Box>
            </form>
          </div>
        )}
        {!displayLogin && (
          <div className="sign-in-wrapper">
            <form className="sign-in-form" onSubmit={handleRegister}>
              <Typography variant="h5" className="sign-in-title">
                Register
              </Typography>
              {loading && (
                <CircularProgress size={24} className="loading-message" />
              )}
              <TextField
                className="input-field"
                label="Login"
                variant="outlined"
                fullWidth
                value={login}
                onChange={(e) => setLogin(e.target.value)}
                margin="normal"
              />
              <TextField
                className="input-field"
                label="Email"
                variant="outlined"
                type="email"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                margin="normal"
              />
              <TextField
                className="input-field"
                label="Societe"
                variant="outlined"
                fullWidth
                value={ownerName}
                onChange={(e) => setOwnerName(e.target.value)}
                margin="normal"
              />
              <TextField
                className="input-field"
                label="Password"
                variant="outlined"
                type="password"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                margin="normal"
              />
              <Button
                className="submit-button"
                variant="contained"
                color="primary"
                type="submit"
                disabled={loading}
                fullWidth
              >
                Valider
              </Button>
              <Box marginTop={2}>
                <Link className="forgot-password-link" to="/forgot-password">
                  Forgot your password?
                </Link>
              </Box>
            </form>
          </div>
        )}
        <Box marginTop={2}>
          <Link
            className="forgot-password-link"
            onClick={() => setDisplayLogin(!displayLogin)}
          >
            {displayLogin ? "Register?" : "Sign In"}
          </Link>
        </Box>
      </div>
    </div>
  );
}
